import { render, staticRenderFns } from "./ForApproval.vue?vue&type=template&id=21bd9f29&"
import script from "./ForApproval.vue?vue&type=script&lang=js&"
export * from "./ForApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports